import { Box, Text, Title } from "@repo/ui/core";
import styles from "@styles/site.module.css";

type SectionHeaderProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "center" | "left";
};

export function SectionHeader({ eyebrow, title, description, align = "left" }: SectionHeaderProps) {
  return (
    <Box mb={48} ta={align} maw={align === "center" ? 680 : 720} mx={align === "center" ? "auto" : undefined}>
      {eyebrow && (
        <Box mb="md">
          <span className={styles.eyebrow}>{eyebrow}</span>
        </Box>
      )}
      <Title
        order={2}
        fw={650}
        style={{
          fontSize: "clamp(1.75rem, 3vw, 2.5rem)",
          lineHeight: 1.12,
          letterSpacing: "-0.025em",
          textWrap: "balance",
        }}
      >
        {title}
      </Title>
      {description && (
        <Text size="lg" c="dimmed" mt="md" lh={1.65} style={{ maxWidth: "60ch" }} mx={align === "center" ? "auto" : undefined}>
          {description}
        </Text>
      )}
    </Box>
  );
}
